/**
 * @generated SignedSource<<58d2cef38658ff3d348cc525169157d4>>
 * @relayHash b73eeb07332d614a1e170c288004fb18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1f2683e6eae220f79d199a910afd2dcf7eb08534396a7873f206554f42cea781

import type { ConcreteRequest } from 'relay-runtime';
export type FavouriteMenuItemQuery$variables = {
  contentId: string;
};
export type FavouriteMenuItemQuery$data = {
  readonly contentOperations: {
    readonly id: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
  } | null;
  readonly singleContent: {
    readonly id: string | null;
    readonly metadata: {
      readonly currentuser: {
        readonly favourited: {
          readonly isFavourite: boolean | null;
        } | null;
      } | null;
    };
    readonly type: string | null;
  } | null;
};
export type FavouriteMenuItemQuery = {
  response: FavouriteMenuItemQuery$data;
  variables: FavouriteMenuItemQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "args": (v1/*: any*/),
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
            "kind": "LinkedField",
            "name": "currentuser",
            "plural": false,
            "selections": [
              {
                "concreteType": "FavouritedSummary",
                "kind": "LinkedField",
                "name": "favourited",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "alias": "contentOperations",
    "args": (v1/*: any*/),
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FavouriteMenuItemQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FavouriteMenuItemQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "b73eeb07332d614a1e170c288004fb18",
    "id": "1f2683e6eae220f79d199a910afd2dcf7eb08534396a7873f206554f42cea781",
    "metadata": {},
    "name": "FavouriteMenuItemQuery",
    "operationKind": "query",
    "text": "query FavouriteMenuItemQuery($contentId:ID!){singleContent(id:$contentId){id,type,metadata{currentuser{favourited{isFavourite}}}},contentOperations:singleContent(id:$contentId){id,operations{operation,targetType}}}"
  }
};
})();

(node as any).hash = "b2cb562e5c9d7e229a13677a47c445f2";

export default node;
